<template>
	<v-list-item>
		<v-list-item-content>
			<v-list-item-title
				v-text="mappedNotification.title"
			/>
			<v-list-item-subtitle>
				<a
					v-if="needsLink"
					href="#"
					@click.stop.prevent="open"
					v-text="mappedNotification.linkTitle"
				/>
			</v-list-item-subtitle>
			<v-list-item-subtitle
				v-text="createdAt"
			/>
		</v-list-item-content>
		<v-list-item-action>
			<v-tooltip left>
				<template #activator="{ on }">
					<v-btn
						icon
						v-on="on"
						@click="read"
					>
						<v-icon color="grey lighten-1">mdi-close</v-icon>
					</v-btn>
				</template>

				<span>Удалить</span>
			</v-tooltip>
		</v-list-item-action>
	</v-list-item>
</template>

<script>
import NotificationMapper from '@/utils/notification-mapper';

export default {
	name: 'NotificationListItem',
	props: {
		notification: {
			type: Object,
			required: true,
		},
	},
	computed: {
		mappedNotification() {
			const mapper = new NotificationMapper();
			return mapper.execute(this.notification);
		},
		createdAt() {
			return this.$formatDateTime(this.notification.created_at);
		},
		needsLink() {
			return !!this.mappedNotification.linkTitle;
		},
	},
	methods: {
		read() {
			this.$emit('read', this.notification);
		},
		open() {
			this.$emit('open', this.notification);
			this.$router.push(this.mappedNotification.to);
		},
	},
};
</script>

<style scoped>

</style>
